import React from 'react';
import { Body, Box, Icon } from '@hover/blueprint';
import { iPhone } from '@hover/icons';

const SDRCallUs = () => (
  <Box flexDir="column">
    <Body
      size={300}
      isBold
      letterSpacing="0.15em"
      textTransform="uppercase"
      mb={3}
    >
      Want to skip the form? Call us instead
      <br />
      Mon-Fri, 9AM-5PM ET
    </Body>
    <Box alignItems="center">
      <Box p={2} bgColor="primary.100" borderRadius="50%" mr={2}>
        <Icon icon={iPhone} size="small" color="primary" />
      </Box>
      <Body size={500}>
        <a href="tel:+18449505074">(844) 950-5074</a>
      </Body>
    </Box>
  </Box>
);

export default SDRCallUs;
